import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=25b3b5e8&"
import script from "./DeleteIcon.vue?vue&type=script&lang=js&"
export * from "./DeleteIcon.vue?vue&type=script&lang=js&"
import style0 from "./DeleteIcon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports